import React from "react"
import { Link, navigate } from "gatsby"
import logo from "../images/INRM-Shillong.png"
import direction from "../images/inrm-direction.png"
import "../styles/style.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTwitterSquare,
  faFacebookSquare,
  faInstagramSquare,
  faYoutubeSquare,
  faAccessibleIcon,
} from "@fortawesome/free-brands-svg-icons"
import { faSearch, faUniversalAccess } from "@fortawesome/free-solid-svg-icons"
const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(null)
  const [title, setTitle] = React.useState("")
  const [fontSize, setFontSize] = React.useState(14)
  const [showModal, setShowModal] = React.useState(false)
  const modalRef = React.useRef()

  const handleModalClick = e => {
    e.stopPropagation()
  }

  const handleOverlayClick = () => {
    setShowModal(false)
  }
  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const search = () => {
    if (title !== "") {
      setShowModal(false)
      navigate(`/search/?title=${encodeURIComponent(title)}`)
    }
  }

  const handleDropdownClick = dropdownId => {
    setIsDropdownOpen(dropdownId === isDropdownOpen ? null : dropdownId)
  }

  const handleInputChange = event => {
    setTitle(event.target.value)
  }

  function handleIncreaseFontSize() {
    setFontSize(fontSize + 2)
  }

  function handleDecreaseFontSize() {
    setFontSize(fontSize - 2)
  }

  function handleResetFontSize() {
    setFontSize(14)
  }

  const handleSkipToMainContent = () => {
    const section = document.querySelector("#main-content")
    const offset = 100 // Change this value to adjust the amount of padding
    const elementPosition = section.getBoundingClientRect().top
    const offsetPosition = elementPosition - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  return (
    <section>
      <section className="overlay z-10 w-full bg-teal-900 text-white flex justify-end items-center">
        <div className="secondary-dropdown">
          <button
            aria-label="Skip to main content"
            title="Skip to main content"
            className="px-3 border-x-2 py-2 text-white"
            onClick={handleSkipToMainContent}
          >
            <span className="text-sm">Skip to main content</span>
          </button>
        </div>
        <div className="secondary-dropdown">
          <button
            aria-label="Accessible"
            className="px-3 py-2 text-white secondary-dropbtn"
          >
            <FontAwesomeIcon
              className="font-bold"
              icon={faAccessibleIcon}
              size="1x"
            />
          </button>
          <div className="secondary-dropdown-content cursor-pointer font-bold">
            <a href={void 0} onClick={handleIncreaseFontSize}>
              A<sup>+</sup>
            </a>
            <a href={void 0} onClick={handleResetFontSize}>
              A
            </a>
            <a href={void 0} onClick={handleDecreaseFontSize}>
              A<sup>-</sup>
            </a>
          </div>
        </div>
        <div className="secondary-dropdown">
          <Link
            title="Screen reader access"
            className="border-l-2 px-3 py-2 text-white secondary-dropbtn"
            to="/screen-reader-access"
          >
            <FontAwesomeIcon
              className="font-bold"
              icon={faUniversalAccess}
              size="1x"
            />
          </Link>
        </div>
        {/* <div className="secondary-dropdown">
          <button aria-label="Search" title='Search Content' className="border-l-2 px-3 py-2 text-white secondary-dropbtn" onClick={() => setShowModal(true)}><FontAwesomeIcon className='font-bold' icon={faSearch} size="1x" /></button>
        </div> */}
        {showModal ? (
          <>
            <div
              onClick={handleOverlayClick}
              className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
              <div
                ref={modalRef}
                onClick={handleModalClick}
                className="border-0 rounded-full shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
              >
                <div className="relative flex-auto">
                  <div className="container flex justify-center items-center">
                    <div className="relative">
                      <input
                        value={title}
                        onChange={handleInputChange}
                        type="text"
                        className="h-14 w-96 text-gray-800 text-sm pl-3 rounded-full pr-16 z-0 focus:shadow focus:outline-none"
                        placeholder="Search anything..."
                      />
                      <div className="absolute top-1 right-1">
                        <button
                          onClick={search}
                          className="h-12 w-12 text-white rounded-full py-3 px-5 bg-gray-800 hover:bg-gray-600"
                        >
                          <FontAwesomeIcon
                            title="Search"
                            className="font-bold"
                            icon={faSearch}
                            size="1x"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="backdrop-blur-sm opacity-50 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </section>
      <header className="px-1 w-full h-16 z-10 bg-black drop-shadow-lg shadow-md fixed top-10">
        <div className="md:px-0 h-full mx-auto flex justify-between items-center justify-items-between">
          <Link to="/">
            <img
              src={logo}
              alt="My Image"
              width={150}
              className="max-w-2xl sm:scale-20 md:scale-30 lg:scale-50 sm:float-left md:order-first"
            />
          </Link>
          <ul
            id="menu"
            className={`${
              isOpen ? "" : "hidden"
            } fixed top-0 right-0 lg:mx-8 px-10 py-16 
                md:relative bg-black custom:flex md:p-0 md:bg-white-900 custom:flex-row custom:space-x-6 `}
          >
            <li className="my-2 p-2">
              <Link
                activeClassName="active"
                className="text-white text-sm my-2 hover:border-b-2 p-2"
                to="/"
              >
                Home
              </Link>
            </li>

            <li className="my-2 p-2">
              <Link
                activeClassName="active"
                className="text-white text-sm my-2 hover:border-b-2 p-2"
                to="/about-us"
              >
                About Us
              </Link>
            </li>
            <li className="my-2 p-2">
              <Link
                activeClassName="active"
                className="text-white text-sm my-2 hover:border-b-2 p-2"
                to="/gis"
              >
                GIS Dashboard
              </Link>
            </li>

            <li>
              <div
                className="group inline-block "
                onMouseEnter={() => handleDropdownClick("advertisements")}
                onMouseLeave={() => handleDropdownClick("advertisements")}
                // onClick={() => handleDropdownClick('advertisements')}
              >
                <button className="outline-none focus:outline-none  rounded-sm flex items-center min-w-32">
                  <Link
                    activeClassName="active"
                    partiallyActive={true}
                    to="/advertisements"
                    className={`pointer-events-none py-3 text-sm flex-1 text-white my-2 ${
                      isDropdownOpen === "advertisements" ? "border-b-2" : ""
                    } hover:border-b-2`}
                  >
                    Advertisements
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 text-white
      transition  ease-in-out  "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </button>
                <ul
                  className={`bg-white border-teal-800 border-t-4 transform ${
                    isDropdownOpen === "advertisements"
                      ? "scale-100"
                      : "scale-0"
                  } absolute transition ease-in-out min-w-32 z-40 p-4`}
                >
                  {/* <li className='my-2'>
                    <Link partiallyActive={true} activeClassName="active-child" className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out" to="/advertisements/tenders" >
                      Tenders
                    </Link>
                  </li> */}
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/advertisements/procurements"
                    >
                      Procurement
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/advertisements/recruitments"
                    >
                      Recruitment
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/advertisements/tenders"
                    >
                      Tenders
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div
                className="group inline-block "
                onMouseEnter={() => handleDropdownClick("knowledge-portal")}
                onMouseLeave={() => handleDropdownClick("knowledge-portal")}
                // onClick={() => handleDropdownClick('knowledge-portal')}
              >
                <button className="outline-none focus:outline-none  rounded-sm flex items-center min-w-32">
                  <Link
                    activeClassName="active"
                    partiallyActive={true}
                    to="/knowledge-portal"
                    className={`pointer-events-none py-3 text-sm flex-1 text-white my-2 ${
                      isDropdownOpen === "knowledge-portal" ? "border-b-2" : ""
                    } hover:border-b-2`}
                  >
                    Knowledge Portal
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 text-white
      transition  ease-in-out  "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </button>
                <ul
                  className={`bg-white border-teal-800 border-t-4 transform ${
                    isDropdownOpen === "knowledge-portal"
                      ? "scale-100"
                      : "scale-0"
                  } absolute transition ease-in-out min-w-32 z-40 p-4`}
                >
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/knowledge-portal/trainings"
                    >
                      Trainings
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/knowledge-portal/programmes"
                    >
                      Programmes
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/knowledge-portal/news-and-events"
                    >
                      News &amp; Events
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/knowledge-portal/success-stories"
                    >
                      Success Stories
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/knowledge-portal/reports"
                    >
                      Reports
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      partiallyActive={true}
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/Update_of_the_weeks_api"
                    >
                      Updates of the Week
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            <li className="my-2 p-2">
              <Link
                activeClassName="active"
                className="text-white text-sm hover:border-b-2 p-2"
                to="/publications"
              >
                Publications
              </Link>
            </li>
            <li>
              <div
                className="group inline-block "
                onMouseEnter={() => handleDropdownClick("gallery")}
                onMouseLeave={() => handleDropdownClick("gallery")}
                // onClick={() => handleDropdownClick('gallery')}
              >
                <button className="outline-none focus:outline-none rounded-sm flex items-center min-w-32">
                  <Link
                    activeClassName="active"
                    partiallyActive={true}
                    to="/gallery"
                    className={`pointer-events-none py-3 text-sm flex-1 text-white my-2 ${
                      isDropdownOpen === "gallery" ? "border-b-2" : ""
                    } hover:border-b-2`}
                  >
                    Gallery
                  </Link>
                  <span>
                    <svg
                      className="fill-current h-4 w-4 text-white
      transition  ease-in-out  "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </span>
                </button>
                <ul
                  className={`bg-white border-teal-800 border-t-4 transform ${
                    isDropdownOpen === "gallery" ? "scale-100" : "scale-0"
                  } absolute transition ease-in-out min-w-32 z-40 p-4`}
                >
                  <li className="my-2">
                    <Link
                      activeClassName="active-child"
                      className="text-black hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/gallery/picture-gallery"
                    >
                      Pictures
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link
                      activeClassName="active-child"
                      className="text-black  hover:text-white hover:bg-teal-900 block px-1 text-sm font-medium transition  ease-in-out"
                      to="/gallery/video-gallery"
                    >
                      Videos
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

          <div className="flex items-center custom:hidden">
            <button
              className="text-white text-4xl font-bold opacity-70 hover:border-b-2  p-2"
              onClick={toggleMenu}
            >
              &#9776;
            </button>
          </div>
        </div>
      </header>
      <main>
        <br />
        <br />
        <div style={{ fontSize: `${fontSize}px` }}>{children}</div>
      </main>
      <footer style={{ fontSize: `${fontSize}px` }} className="bg-gray-800">
        <div className="container p-3 md:mx-auto lg:mx-auto lg:justify-items-center sm:py-12 lg:py-24 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2">
          <div>
            <h4 className="text-teal-500 text-lg pb-2">INRM Home</h4>
            <ul className="text-white space-y-2 pr-2">
              <li>
                <Link to="/">
                  {" "}
                  <img
                    src={logo}
                    alt="My Image"
                    width={120}
                    className="max-w-sm"
                  />
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-teal-500 text-lg pb-2">Institutions</h4>
            <ul className="text-white space-y-2 pr-2">
              <li>
                <a
                  href="https://www.mbda.gov.in/"
                  target="_blank"
                  title="Go to external website https://www.mbda.gov.in/"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Meghalaya Basin Development Authority
                </a>
              </li>
              <li>
                <a
                  href="https://www.miemeghalaya.org/"
                  target="_blank"
                  title="Go to external website https://www.miemeghalaya.org/"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Institute of Entrepreneurship
                </a>
              </li>
              <li>
                <a
                  href="https://www.megplanning.gov.in/"
                  target="_blank"
                  title="Go to external website https://www.megplanning.gov.in/"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Planning Department
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-teal-500 text-lg pb-2">Follow Us</h4>
            <ul className="text-white space-y-2 pr-2">
              <li>
                <a
                  href="https://www.facebook.com/mbdashillong/"
                  target="_blank"
                  title="facebook"
                >
                  <FontAwesomeIcon
                    icon={faFacebookSquare}
                    className="text-xl"
                    size="1x"
                  />{" "}
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/IBDLP_Meghalaya"
                  target="_blank"
                  title="twitter"
                >
                  <FontAwesomeIcon
                    icon={faTwitterSquare}
                    className="text-xl"
                    size="1x"
                  />{" "}
                  Twitter
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCXdcedNbPhavCUYkVOXdmew"
                  target="_blank"
                  title="youtube"
                >
                  <FontAwesomeIcon
                    icon={faYoutubeSquare}
                    className="text-xl"
                    size="1x"
                  />{" "}
                  Youtube
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/mbda_shillong/"
                  target="_blank"
                  title="instagram"
                >
                  <FontAwesomeIcon
                    icon={faInstagramSquare}
                    className="text-xl"
                    size="1x"
                  />{" "}
                  Insatgram
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-teal-500 text-lg pb-2">Important Links</h4>
            <ul className="text-white space-y-2 pr-2">
              <li>
                <a href="https://www.india.gov.in/"> india.gov.in</a>
              </li>
              <li>
                <a href="https://meghalaya.gov.in/"> meghalaya.gov.in</a>
              </li>
              <li>
                <a href="https://msam.nic.in/"> msam.nic.in</a>
              </li>
              <li>
                <a href="https://mbda.gov.in/"> mbda.gov.in</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-teal-500 text-lg pb-2">Directions</h4>
            <ul className="text-white space-y-2">
              <li>
                <img
                  src={direction}
                  alt="INRM Direction"
                  width={100}
                  className="max-w-sm p-1 bg-white"
                />
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <section style={{ fontSize: `${fontSize}px` }}>
        <div className="container mx-auto px-3 py-24">
          <h1 className="text-center font-bold text-xl">
            Copyright 2019. All rights reserved.
          </h1>
          <div className="w-8/12 container mx-auto">
            <p className="text-center py-3">
              Content maintained and updated by Institute of Natural Resources
              Management, Government of Meghalaya All Queries/Comments regarding
              the content on this site may be sent to minr.mbda@gmail.com
            </p>
          </div>
        </div>
      </section>
    </section>
  )
}
export default Layout
